import { ComparableDepositExtended } from '@/page-src/product/pages/deposits/api';
import { parse2fToNumber } from '@/src/utils/parse-nf-to-number';

export const getDepositsMainInfoToDisplay = (result: ComparableDepositExtended) => {
  const { deposit, interestRate2f, maxInterestRate2f } = result;

  if (!deposit.isExposable) {
    return {
      maxInterestRate: '정보 준비 중',
      interestRate: '정보 준비 중',
    };
  }

  if (deposit.isStopped) {
    return {
      maxInterestRate: '단종',
      interestRate: '단종',
    };
  }

  return {
    maxInterestRate: `${parse2fToNumber(String(maxInterestRate2f))}%`,
    interestRate: `${parse2fToNumber(String(interestRate2f))}%`,
  };
};
